module.exports = __webpack_public_path__ + "static/media/mysql.e55acd45.png";